document.addEventListener('DOMContentLoaded', function(){
    const newsletterNewInput = document.querySelector('.js-newsletter-new_input');
    const newsletterNewButton = document.querySelector('.js-newsletter-new_button');
    const acceptTerms = document.querySelector('input.js-acceptTerms');

    if (newsletterNewInput) {
        newsletterNewInput.setAttribute('disabled', 'disabled');
    }

    if (newsletterNewButton) {
        newsletterNewButton.setAttribute('disabled', 'disabled');
    }

    if (acceptTerms) {
        acceptTerms.addEventListener('click', function() {
            let unchecked = document.querySelector('input.js-acceptTerms');
            if (unchecked.checked === true) {
                newsletterNewInput.removeAttribute('disabled');
                newsletterNewButton.removeAttribute('disabled');
            } else {
                newsletterNewInput.setAttribute('disabled', 'disabled');
                newsletterNewButton.setAttribute('disabled', 'disabled');
            }
        });
    }

    function accordeonFooter() {
        var acc = document.getElementsByClassName("acc-head");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }

    function checkPosition() {
        if (window.matchMedia('(max-width: 749px)').matches) {
            accordeonFooter();
        }
    }
    checkPosition();
});


